import "./Rodape.css";
import { useEffect } from "react";
import logo from '../../logo.svg';
import icon2 from '../../img/icon_insta.svg';
import icon6 from '../../img/icon_wpp.svg';


function Rodape() {

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("fade-in");
                }
            });
        }, { threshold: 0.1 });

        // Observamos todos os elementos do rodapé, incluindo a logo
        document.querySelectorAll(".title-rodape, .links-rodape, .link-rede img, .logo-rodape img, .logo-ba, .copy, .desc-rodape-span, .rodape-section").forEach((el) => observer.observe(el));

        return () => observer.disconnect();
    }, []);


    const anoAtual = new Date().getFullYear();

    return (
        <div className="container-inicial container-rodape" id='rodape'>
            <div className="container-rodape-sections">
                <div className="logo-rodape d-none">
                    <img src={logo} alt="Logotipo da Blue Análises e Serviços Ambientais" loading="lazy" />
                </div>

                <div className="rodape-section">
                    <h6 className="title-rodape">Sobre Nós</h6>
                    <div className="rodape-links">
                        <div><a className="links-rodape" href="/" aria-label="Ir para a página inicial">Home</a></div>
                        <div><a className="links-rodape" href="#sobre" aria-label="Ir para a seção Sobre nós">Sobre nós</a></div>
                        <div><a className="links-rodape" href="#servicos" aria-label="Ir para a seção Serviços">Serviços</a></div>
                        <div><a className="links-rodape" href="#clientes" aria-label="Ir para a seção Clientes">Clientes</a></div>
                    </div>
                </div>

                <div className="rodape-section">
                    <h6 className="title-rodape">Serviços</h6>
                    <div className="rodape-links">
                        <div><a className="links-rodape" href="#servico-consultoria" aria-label="Consultoria Ambiental">Consultoria Ambiental</a></div>
                        <div><a className="links-rodape" href="#servico-licenciamento" aria-label="Licenciamento Ambiental">Licenciamento Ambiental</a></div>
                        <div><a className="links-rodape" href="#servico-projetos" aria-label="Projetos de Estação de Tratamento">Projetos de Estação de Tratamento</a></div>
                        <div><a className="links-rodape" href="#servico-transporte" aria-label="Transporte e Destinação de Resíduos">Transporte e Destinação de Resíduos</a></div>
                    </div>
                </div>

                <div className="rodape-section">
                    <h6 className="title-rodape">Contato</h6>
                    <div className="rodape-links">
                        <div><a className="links-rodape" href="tel:03233210063" type="tel" aria-label="Ligar para telefone fixo (32) 3321-0063">Fixo 32 3321-0063</a></div>
                        <div><a className="links-rodape" href="https://wa.me/5532988945096?text=Olá%2C%20vim%20pelo%20site%20e%20quero%20saber%20mais%20informações%20sobre%20os%20serviços%20da%20Blue%20Análises%20e%20Serviços%20Ambientais." aria-label="Enviar mensagem para o WhatsApp (32) 98894-5096">WhatsApp 32 98894-5096</a></div>
                    </div>
                </div>

                <div className="rodape-section">
                    <h6 className="title-rodape">Redes Sociais</h6>
                    <div className="desc-info">
                        <a className="links-rodape link-rede" href="https://www.instagram.com/blueanalises/" target="_blank" rel="noopener noreferrer" aria-label="Visitar perfil do Instagram da empresa">
                            <img src={icon2} alt="Ícone de acesso ao Instagram da empresa" loading="lazy" />
                        </a>
                        <a className="links-rodape link-rede" href="https://wa.me/553233210063?text=Olá%2C%20vim%20pelo%20site%20e%20quero%20saber%20mais%20informações%20sobre%20os%20serviços%20da%20Blue%20Análises%20e%20Serviços%20Ambientais." target="_blank" rel="noopener noreferrer" aria-label="Conversar com a empresa via WhatsApp">
                            <img src={icon6} alt="Ícone do WhatsApp para atendimento da empresa" loading="lazy" />
                        </a>
                    </div>
                </div>
            </div>

            <div className="container-copy">
                <p className="copy">© {anoAtual} Copyright - Blue Análises e Serviços Ambientais Ltda. Todos os direitos reservados.</p>
                <span className="desc-rodape-span">Desenvolvido por <a className="links-rodape" href="https://casoftwares.com.br/" aria-label="Acessar site da CA Softwares">CA Softwares</a>
                </span>
                <div className="logo-rodape">
                    <img className="logo-ba" src={logo} alt="Logotipo da Blue Análises na área de rodapé" loading="lazy" />
                </div>
            </div>
        </div>


    );
}

export default Rodape;
